/* AUTO-GENERATED by research/build_uk.py from research/raw/uk_verified.json.
   Do not edit by hand: the previous hand-written version carried 33 errors.
   Regenerate with: python3 research/build_uk.py

   31 transplant units and 22 H&I laboratories, verified against the NHSBT
   transplant unit directory, the NHSBT Annual Activity Report, NHSBT INF1466/3.1 (laboratory
   catchments) and the UKAS 9239 schedule.

   The structural fact that drives the commercial model: roughly 31 transplant units are
   served by only 22 laboratories, and the laboratory usually holds the reagent budget.
   Selling to the unit and ignoring the laboratory loses the order.
*/

import type { Site } from './atlas';

export const UK_SITES: Site[] = [
 {
  "id": "gbr-belfast",
  "name": "Belfast City Hospital, Belfast Health and Social Care Trust",
  "short": "Belfast",
  "iso3": "GBR",
  "city": "Belfast",
  "region": "Northern Ireland",
  "lat": 54.5822,
  "lon": -5.9412,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 89,
    "living": 61,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": null,
  "note": "Paediatric kidney via Royal Belfast Hospital for Sick Children; NHSBT reports both under 'Belfast'. Programmes: kidney. H&I laboratory: Northern Ireland Regional H&I Laboratory, Belfast."
 },
 {
  "id": "gbr-qehb",
  "name": "Queen Elizabeth Hospital Birmingham, University Hospitals Birmingham NHS FT",
  "short": "QEHB",
  "iso3": "GBR",
  "city": "Birmingham",
  "region": "England",
  "lat": 52.4526,
  "lon": -1.9387,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 3,
  "labNote": null,
  "note": "NOT a pancreas centre. Absent from the ODT pancreas unit list and from Activity Report Table 6.8. Programmes: kidney, liver, heart, lung. H&I laboratory: NHSBT Birmingham."
 },
 {
  "id": "gbr-birmingham-children-s",
  "name": "Birmingham Women's and Children's NHS Foundation Trust",
  "short": "Birmingham Children's",
  "iso3": "GBR",
  "city": "Birmingham",
  "region": "England",
  "lat": 52.4526,
  "lon": -1.9387,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [],
  "tier": 3,
  "labNote": null,
  "note": "NOT a heart centre. Paediatric cardiothoracic is Great Ormond Street and Newcastle only. Programmes: kidney, liver, intestine. H&I laboratory: NHSBT Birmingham."
 },
 {
  "id": "gbr-bristol",
  "name": "Southmead Hospital, North Bristol NHS Trust",
  "short": "Bristol",
  "iso3": "GBR",
  "city": "Bristol",
  "region": "England",
  "lat": 51.494,
  "lon": -2.59,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 112,
    "living": 36,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": null,
  "note": "Paediatric kidney delivered at Bristol Royal Hospital for Children; 14 paediatric transplants 2024/25. Programmes: kidney. H&I laboratory: Bristol (Southmead) H&I."
 },
 {
  "id": "gbr-cambridge",
  "name": "Addenbrooke's Hospital, Cambridge University Hospitals NHS FT",
  "short": "Cambridge",
  "iso3": "GBR",
  "city": "Cambridge",
  "region": "England",
  "lat": 52.1748,
  "lon": 0.1408,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 161,
    "living": 21,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 111,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 21,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": null,
  "note": "NOT an islet centre. Islet units are Edinburgh, King's, Manchester, Newcastle, Oxford only. Programmes: kidney, liver, pancreas, intestine. H&I laboratory: Cambridge Tissue Typing."
 },
 {
  "id": "gbr-cardiff",
  "name": "University Hospital of Wales, Cardiff and Vale UHB",
  "short": "Cardiff",
  "iso3": "GBR",
  "city": "Cardiff",
  "region": "Wales",
  "lat": 51.5074,
  "lon": -3.1897,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 127,
    "living": 47,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 7,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": null,
  "note": "NO liver programme. Only adult solid organ transplant centre in Wales. Programmes: kidney, pancreas. H&I laboratory: WTAIL, Welsh Blood Service."
 },
 {
  "id": "gbr-coventry",
  "name": "University Hospital Coventry (Walsgrave), University Hospitals Coventry and Warwickshire NHS Trust",
  "short": "Coventry",
  "iso3": "GBR",
  "city": "Coventry",
  "region": "England",
  "lat": 52.422,
  "lon": -1.439,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 68,
    "living": 18,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": null,
  "note": "Genuine unit. Formal transplant network partnership with Oxford since 1 June 2016. Programmes: kidney. H&I laboratory: NHSBT Birmingham."
 },
 {
  "id": "gbr-edinburgh",
  "name": "Royal Infirmary of Edinburgh, NHS Lothian",
  "short": "Edinburgh",
  "iso3": "GBR",
  "city": "Edinburgh",
  "region": "Scotland",
  "lat": 55.9218,
  "lon": -3.1382,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 98,
    "living": 43,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 66,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 13,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": null,
  "note": "Programmes: kidney, liver, pancreas, islet. H&I laboratory: SNBTS H&I, Royal Infirmary of Edinburgh."
 },
 {
  "id": "gbr-qeuh-glasgow",
  "name": "Queen Elizabeth University Hospital, NHS Greater Glasgow and Clyde",
  "short": "QEUH Glasgow",
  "iso3": "GBR",
  "city": "Glasgow",
  "region": "Scotland",
  "lat": 55.862,
  "lon": -4.339,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 3,
  "labNote": null,
  "note": "Programmes: kidney. H&I laboratory: West of Scotland H&I, Gartnavel General (NHSGGC)."
 },
 {
  "id": "gbr-rhc-glasgow",
  "name": "Royal Hospital for Children, Glasgow",
  "short": "RHC Glasgow",
  "iso3": "GBR",
  "city": "Glasgow",
  "region": "Scotland",
  "lat": 55.862,
  "lon": -4.339,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [],
  "tier": 3,
  "labNote": null,
  "note": "Programmes: kidney. H&I laboratory: West of Scotland H&I, Gartnavel General (NHSGGC)."
 },
 {
  "id": "gbr-golden-jubilee",
  "name": "Golden Jubilee National Hospital",
  "short": "Golden Jubilee",
  "iso3": "GBR",
  "city": "Clydebank",
  "region": "Scotland",
  "lat": 55.908,
  "lon": -4.406,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "cardiothoracic",
    "year": 2024,
    "total": 29,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": null,
  "note": "Hearts only. No lung transplant programme anywhere in Scotland: confirmed, Table 7.10 shows zero Glasgow lung transplants. Programmes: heart. H&I laboratory: West of Scotland H&I, Gartnavel General (NHSGGC)."
 },
 {
  "id": "gbr-leeds",
  "name": "St James's University Hospital, Leeds Teaching Hospitals NHS Trust",
  "short": "Leeds",
  "iso3": "GBR",
  "city": "Leeds",
  "region": "England",
  "lat": 53.8067,
  "lon": -1.5195,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 181,
    "living": 51,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 106,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": null,
  "note": "NOT a pancreas centre. Absent from ODT pancreas list and Table 6.8. Programmes: kidney, liver. H&I laboratory: Leeds Transplant Immunology."
 },
 {
  "id": "gbr-leicester",
  "name": "Leicester General Hospital, University Hospitals of Leicester NHS Trust",
  "short": "Leicester",
  "iso3": "GBR",
  "city": "Leicester",
  "region": "England",
  "lat": 52.6369,
  "lon": -1.079,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 121,
    "living": 25,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": null,
  "note": "NOT a pancreas centre. Absent from ODT pancreas list and Table 6.8. Programmes: kidney. H&I laboratory: Leicester H&I."
 },
 {
  "id": "gbr-liverpool",
  "name": "Royal Liverpool University Hospital, Liverpool University Hospitals NHS FT",
  "short": "Liverpool",
  "iso3": "GBR",
  "city": "Liverpool",
  "region": "England",
  "lat": 53.4084,
  "lon": -2.966,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 118,
    "living": 32,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": null,
  "note": "Programmes: kidney. H&I laboratory: Liverpool University Hospital H&I."
 },
 {
  "id": "gbr-gosh",
  "name": "Great Ormond Street Hospital for Children NHS FT",
  "short": "GOSH",
  "iso3": "GBR",
  "city": "London",
  "region": "England",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [],
  "tier": 3,
  "labNote": null,
  "note": "GOSH is a cardiothoracic transplant unit as well as a kidney one: 17 paediatric and 3 adult cardiothoracic transplants 2024/25. Programmes: kidney, heart, lung. H&I laboratory: Royal Free (Anthony Nolan)."
 },
 {
  "id": "gbr-guy-s",
  "name": "Guy's Hospital, Guy's and St Thomas' NHS FT",
  "short": "Guy's",
  "iso3": "GBR",
  "city": "London",
  "region": "England",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 230,
    "living": 63,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 12,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": null,
  "note": "NOT an islet centre. Paediatric kidney delivered at Evelina and reported by NHSBT under Guy's. Programmes: kidney, pancreas. H&I laboratory: Clinical Transplantation Laboratory (Synnovis), Guy's."
 },
 {
  "id": "gbr-king-s-college",
  "name": "King's College Hospital NHS FT",
  "short": "King's College",
  "iso3": "GBR",
  "city": "London",
  "region": "England",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "liver",
    "year": 2024,
    "total": 156,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": null,
  "note": "King's IS an islet unit and a paediatric intestinal unit, both missing from the atlas. Not a kidney transplant centre in its own right. Programmes: liver, islet, intestine. H&I laboratory: Guy's / NHSBT Tooting."
 },
 {
  "id": "gbr-st-george-s",
  "name": "St George's Hospital, St George's University Hospitals NHS FT",
  "short": "St George's",
  "iso3": "GBR",
  "city": "London",
  "region": "England",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 151,
    "living": 41,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": null,
  "note": "Genuine unit, 151 adult kidney transplants 2024/25, larger than Cardiff or Liverpool. Programmes: kidney. H&I laboratory: Guy's / NHSBT Tooting."
 },
 {
  "id": "gbr-royal-free",
  "name": "The Royal Free Hospital, Royal Free London NHS FT",
  "short": "Royal Free",
  "iso3": "GBR",
  "city": "London",
  "region": "England",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 138,
    "living": 24,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 128,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": null,
  "note": "Royal Free IS an adult liver transplant centre (128 transplants 2024/25, 4th largest in the UK) and is NOT a pancreas centre. The atlas has this exactly backwards. Programmes: kidney, liver. H&I laboratory: Anthony Nolan Histocompatibility Laboratories (on the Royal Free site)."
 },
 {
  "id": "gbr-royal-london",
  "name": "The Royal London Hospital, Barts Health NHS Trust",
  "short": "Royal London",
  "iso3": "GBR",
  "city": "London",
  "region": "England",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 157,
    "living": 32,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": null,
  "note": "Programmes: kidney. H&I laboratory: Bart's and The Royal London H&I."
 },
 {
  "id": "gbr-wlrtc-hammersmith",
  "name": "West London Renal and Transplant Centre, Hammersmith Hospital, Imperial College Healthcare NHS Trust",
  "short": "WLRTC / Hammersmith",
  "iso3": "GBR",
  "city": "London",
  "region": "England",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 3,
  "labNote": null,
  "note": "NHSBT and INF1466 both use the name 'WLRTC (Hammersmith)'. Programmes: kidney, pancreas. H&I laboratory: H&I, North West London Pathology (Hammersmith)."
 },
 {
  "id": "gbr-harefield",
  "name": "Harefield Hospital, Guy's and St Thomas' NHS FT",
  "short": "Harefield",
  "iso3": "GBR",
  "city": "Harefield",
  "region": "England",
  "lat": 51.6021,
  "lon": -0.4899,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "cardiothoracic",
    "year": 2024,
    "total": 62,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": null,
  "note": "INF1466 explicitly assigns Harefield to WLRTC (Hammersmith), NOT to Guy's, despite the 2021 trust merger. Programmes: heart, lung. H&I laboratory: WLRTC (Hammersmith)."
 },
 {
  "id": "gbr-manchester",
  "name": "Manchester Royal Infirmary, Manchester University NHS FT",
  "short": "Manchester",
  "iso3": "GBR",
  "city": "Manchester",
  "region": "England",
  "lat": 53.4622,
  "lon": -2.2261,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 222,
    "living": 58,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 24,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": null,
  "note": "Paediatric kidney at Royal Manchester Children's, reported by NHSBT under Manchester. Programmes: kidney, pancreas, islet. H&I laboratory: Transplantation Laboratory, Manchester."
 },
 {
  "id": "gbr-wythenshawe",
  "name": "Wythenshawe Hospital, Manchester University NHS FT",
  "short": "Wythenshawe",
  "iso3": "GBR",
  "city": "Manchester",
  "region": "England",
  "lat": 53.4622,
  "lon": -2.2261,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "cardiothoracic",
    "year": 2024,
    "total": 54,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": null,
  "note": "NHSBT reports its cardiothoracic activity as 'Manchester'. Programmes: heart, lung. H&I laboratory: Transplantation Laboratory, Manchester."
 },
 {
  "id": "gbr-freeman",
  "name": "Freeman Hospital, Newcastle upon Tyne Hospitals NHS FT",
  "short": "Freeman",
  "iso3": "GBR",
  "city": "Newcastle",
  "region": "England",
  "lat": 54.9783,
  "lon": -1.6178,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 127,
    "living": 37,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 50,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "cardiothoracic",
    "year": 2024,
    "total": 60,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 6,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": null,
  "note": "The only UK centre running all six of kidney, liver, heart, lung, pancreas and islet, adult and paediatric. Commercially the single most complete account in the UK. Programmes: kidney, liver, heart, lung, pancreas, islet. H&I laboratory: NHSBT Newcastle."
 },
 {
  "id": "gbr-nottingham",
  "name": "Nottingham City Hospital, Nottingham University Hospitals NHS Trust",
  "short": "Nottingham",
  "iso3": "GBR",
  "city": "Nottingham",
  "region": "England",
  "lat": 52.976,
  "lon": -1.181,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 59,
    "living": 17,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": null,
  "note": "Genuine unit and, missed by the atlas, a PAEDIATRIC kidney transplant centre: 10 paediatric transplants 2024/25. Programmes: kidney. H&I laboratory: NHSBT Barnsley."
 },
 {
  "id": "gbr-oxford",
  "name": "Churchill Hospital, Oxford University Hospitals NHS FT",
  "short": "Oxford",
  "iso3": "GBR",
  "city": "Oxford",
  "region": "England",
  "lat": 51.7404,
  "lon": -1.2181,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 187,
    "living": 62,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 38,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "tier": 1,
  "labNote": null,
  "note": "Oxford IS an adult intestinal transplant unit, missing from the atlas programme list. UK's largest pancreas programme (33 SPK 2024/25). Programmes: kidney, pancreas, islet, intestine. H&I laboratory: Transplant Immunology and Immunogenetics, Oxford."
 },
 {
  "id": "gbr-royal-papworth",
  "name": "Royal Papworth Hospital NHS FT",
  "short": "Royal Papworth",
  "iso3": "GBR",
  "city": "Cambridge",
  "region": "England",
  "lat": 52.1748,
  "lon": 0.1408,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [],
  "tier": 3,
  "labNote": null,
  "note": "Largest UK cardiothoracic centre by volume (72 adult transplants 2024/25). Did 1 paediatric transplant in 2024/25. No H&I lab of its own. Programmes: heart, lung. H&I laboratory: Cambridge Tissue Typing."
 },
 {
  "id": "gbr-plymouth",
  "name": "Derriford Hospital, University Hospitals Plymouth NHS Trust",
  "short": "Plymouth",
  "iso3": "GBR",
  "city": "Plymouth",
  "region": "England",
  "lat": 50.416,
  "lon": -4.114,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 52,
    "living": 24,
    "confidence": "verified"
   }
  ],
  "tier": 3,
  "labNote": null,
  "note": "Genuine unit but the smallest adult kidney programme in the UK at 52 transplants. Programmes: kidney. H&I laboratory: Plymouth H&I."
 },
 {
  "id": "gbr-portsmouth",
  "name": "Queen Alexandra Hospital, Portsmouth Hospitals University NHS Trust",
  "short": "Portsmouth",
  "iso3": "GBR",
  "city": "Portsmouth",
  "region": "England",
  "lat": 50.848,
  "lon": -1.068,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 93,
    "living": 28,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": null,
  "note": "Genuine unit, 93 transplants. Has no lab of its own; INF1466 assigns it to Tooting NHSBT with Oxford as first reserve. Programmes: kidney. H&I laboratory: NHSBT Tooting."
 },
 {
  "id": "gbr-sheffield",
  "name": "Northern General Hospital, Sheffield Teaching Hospitals NHS FT",
  "short": "Sheffield",
  "iso3": "GBR",
  "city": "Sheffield",
  "region": "England",
  "lat": 53.411,
  "lon": -1.462,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 71,
    "living": 21,
    "confidence": "verified"
   }
  ],
  "tier": 2,
  "labNote": null,
  "note": "Genuine unit, 71 transplants. Confirmed no longer hosts an NHSBT lab: UKAS 9239 Issue 012 names Barnsley Blood Centre and not Sheffield. Programmes: kidney. H&I laboratory: NHSBT Barnsley."
 },
 {
  "id": "gbr-lab-nhsbt-colindale",
  "name": "NHSBT Colindale H&I Laboratory",
  "short": "NHSBT Colindale",
  "iso3": "GBR",
  "city": "London",
  "region": "",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHSBT. Head of Laboratory Dr Colin Brown. Named as the UKAS 9239 head office address. National registry typing, no deceased-donor catchment. EFI 03-GB-002.998. UKAS 9239 (location code C).",
  "note": "Serves: British Bone Marrow Registry, NHS Cord Blood Bank, HLA-selected platelets."
 },
 {
  "id": "gbr-lab-nhsbt-tooting",
  "name": "NHSBT Tooting H&I Laboratory",
  "short": "NHSBT Tooting",
  "iso3": "GBR",
  "city": "London",
  "region": "",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHSBT. 75 Cranmer Terrace, Tooting SW17 0RB, on the St George's site. Head of Laboratory Dr Deborah Sage. INF1466 pairs it with Guy's as 'Guy's / Tooting NHSBT' across south-east England; Wessex and coastal Hampshire rows name Tooting alone. EFI 03-GB-003.997. UKAS 9239 (location code T).",
  "note": "Serves: St George's, King's College, Guy's, St Thomas', Portsmouth QA, Southampton, Salisbury, Winchester, Ashford William Harvey, Maidstone, Margate QEQM, Brighton, Frimley Park, Croydon, Kingston, Lewisham, Evelina, Jersey General, Isle of Wight St Mary's."
 },
 {
  "id": "gbr-lab-nhsbt-birmingham",
  "name": "NHSBT Birmingham H&I Laboratory",
  "short": "NHSBT Birmingham",
  "iso3": "GBR",
  "city": "Birmingham",
  "region": "",
  "lat": 52.4526,
  "lon": -1.9387,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHSBT. Vincent Drive, Edgbaston B15 2SG. Head of Laboratory Mr Luke Foster. 20 hospitals in INF1466, not 17. EFI 03-GB-020.980. UKAS 9239 (location code B).",
  "note": "Serves: QE Hospital Birmingham, Birmingham Children's, Heartlands, City, Sandwell, Good Hope, Solihull, Burton Queen's, Coventry Walsgrave, Russells Hall, Hereford County, George Eliot, Alexandra Redditch, Royal Shrewsbury, Princess Royal Telford, Walsall Manor, Warwick, New Cross Wolverhampton, Worcestershire Royal, University Hospital North Staffordshire."
 },
 {
  "id": "gbr-lab-nhsbt-filton",
  "name": "NHSBT Filton H&I and Molecular Diagnostics Laboratory",
  "short": "NHSBT Filton",
  "iso3": "GBR",
  "city": "Bristol",
  "region": "",
  "lat": 51.494,
  "lon": -2.59,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHSBT. 500 North Bristol Park, BS34 7QH. Head of Laboratory Dr Anthony Poles. Scope is H&I AND immunohaematology molecular diagnostics. No deceased-donor catchment in INF1466; national reference function. EFI 03-GB-015.985. UKAS 9239 (location code BR).",
  "note": null
 },
 {
  "id": "gbr-lab-nhsbt-barnsley",
  "name": "NHSBT Barnsley H&I Laboratory",
  "short": "NHSBT Barnsley",
  "iso3": "GBR",
  "city": "Barnsley",
  "region": "",
  "lat": 53.5526,
  "lon": -1.4797,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHSBT. Barnsley Blood Centre, Unit D Capital Way. Head of Laboratory Mr Tim Key. Relocation from Sheffield is complete and reflected in UKAS Issue 012. EFI 03-GB-006.994. UKAS 9239 (location code BA).",
  "note": "Serves: Barnsley DGH, Chesterfield, Royal Derby, Doncaster, Nottingham University Hospitals, Rotherham, Sheffield Northern General, Sheffield Royal Hallamshire, Sheffield Children's, King's Mill, Bassetlaw."
 },
 {
  "id": "gbr-lab-nhsbt-newcastle",
  "name": "NHSBT Newcastle H&I Laboratory",
  "short": "NHSBT Newcastle",
  "iso3": "GBR",
  "city": "Newcastle",
  "region": "",
  "lat": 54.9783,
  "lon": -1.6178,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHSBT. Head of Laboratory Dr Arash Akbarzad-Yousefi. EFI 03-GB-004.996. UKAS 9239 (location code N).",
  "note": "Serves: Freeman, Royal Victoria Infirmary, Cumberland Infirmary, Darlington, North Durham, QE Gateshead, James Cook, South Tyneside, North Tees, Sunderland Royal, West Cumberland, NSECH Cramlington."
 },
 {
  "id": "gbr-lab-guy-s",
  "name": "Clinical Transplantation Laboratory, Guy's Hospital",
  "short": "Guy's",
  "iso3": "GBR",
  "city": "London",
  "region": "",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by Synnovis. Operates jointly with NHSBT Tooting in INF1466 as 'Guy's / Tooting NHSBT'. Synnovis is the Guy's and St Thomas' / King's pathology JV with SYNLAB, so purchasing sits at network level.",
  "note": "Serves: Guy's and St Thomas', King's College, Princess Royal University Hospital, Evelina, St George's, London Bridge, St Bartholomew's, Kent and Sussex network."
 },
 {
  "id": "gbr-lab-anthony-nolan",
  "name": "Anthony Nolan Histocompatibility Laboratories, Royal Free Hospital",
  "short": "Anthony Nolan",
  "iso3": "GBR",
  "city": "London",
  "region": "",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by Anthony Nolan. Charity-operated on the Royal Free site. INF1466 names it 'Royal Free (Anthony Nolan)'. UKAS number 8630 and platform list carried over from the earlier research pass and NOT re-verified in this run. Incumbent GenDx is EuroBio-owned: never-sell list. UKAS 8630. Platforms: GenDx NGSgo, Luminex single antigen bead.",
  "note": "Serves: Royal Free, University College Hospital, Whittington, Barnet, North Middlesex, Great Ormond Street, Princess Alexandra Harlow, Luton and Dunstable."
 },
 {
  "id": "gbr-lab-wlrtc-hammersmith",
  "name": "H&I Laboratory, North West London Pathology (Hammersmith)",
  "short": "WLRTC (Hammersmith)",
  "iso3": "GBR",
  "city": "London",
  "region": "",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHS trust. INF1466 name is 'WLRTC (Hammersmith)'. LIVE OPPORTUNITY per earlier pass: NGS HLA typing reagents tender, notice expected 1 Sept 2026, contract Nov 2026 to Oct 2031, flagged SME-suitable. Tender detail NOT re-verified in this run.",
  "note": "Serves: Hammersmith, Charing Cross, St Mary's, Chelsea and Westminster, Harefield, Northwick Park, West Middlesex, Ealing, Hillingdon."
 },
 {
  "id": "gbr-lab-bart-s-and-the-royal-london",
  "name": "H&I Laboratory, Bart's and The Royal London",
  "short": "Bart's and The Royal London",
  "iso3": "GBR",
  "city": "London",
  "region": "",
  "lat": 51.5072,
  "lon": -0.1276,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHS trust. INF1466 catchment does NOT include Norfolk and Norwich, which is a Cambridge hospital. The atlas lists it wrongly.",
  "note": "Serves: The Royal London, Homerton, Newham General, Whipps Cross, Queen's Romford, King George Ilford, Southend, Basildon, Broomfield Chelmsford, Princess Alexandra Harlow."
 },
 {
  "id": "gbr-lab-cambridge",
  "name": "Tissue Typing Laboratory, Addenbrooke's Hospital",
  "short": "Cambridge",
  "iso3": "GBR",
  "city": "Cambridge",
  "region": "",
  "lat": 52.1748,
  "lon": 0.1408,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHS trust. Clinical Director Sarah Peacock (not re-verified this run). Platforms: NGS, One Lambda LabScreen Mixed and Single Antigen.",
  "note": "Serves: Addenbrooke's, Royal Papworth, Bedford, West Suffolk, Colchester, Ipswich, James Paget, Hinchingbrooke, QE King's Lynn, Luton and Dunstable, Norfolk and Norwich."
 },
 {
  "id": "gbr-lab-oxford",
  "name": "Transplant Immunology and Immunogenetics Laboratory, Churchill Hospital",
  "short": "Oxford",
  "iso3": "GBR",
  "city": "Oxford",
  "region": "",
  "lat": 51.7404,
  "lon": -1.2181,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHS trust. UKAS 8758, director Martin Barnardo and platform list carried over from the earlier pass, not re-verified here. UKAS 8758. Platforms: PCR-SSP, NGS, qPCR, Luminex LabScan 3D, single antigen beads.",
  "note": "Serves: John Radcliffe, Churchill, Stoke Mandeville, Horton, Cheltenham, Milton Keynes, Northampton, Royal Berkshire, Wexham Park, Great Western, Wycombe."
 },
 {
  "id": "gbr-lab-leicester",
  "name": "H&I Laboratory, University Hospitals of Leicester",
  "short": "Leicester",
  "iso3": "GBR",
  "city": "Leicester",
  "region": "",
  "lat": 52.6369,
  "lon": -1.079,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHS trust.",
  "note": "Serves: Glenfield, Leicester General, Leicester Royal Infirmary, Pilgrim Boston, Grantham, Kettering, Lincoln County, Peterborough City."
 },
 {
  "id": "gbr-lab-liverpool",
  "name": "H&I Laboratory, Liverpool University Hospitals NHS FT",
  "short": "Liverpool",
  "iso3": "GBR",
  "city": "Liverpool",
  "region": "",
  "lat": 53.4084,
  "lon": -2.966,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHS trust. INF1466 name is 'Liverpool University Hospital'.",
  "note": "Serves: Royal Liverpool, Broadgreen, Aintree, Alder Hey, Liverpool Heart and Chest, Walton Centre, Countess of Chester, Leighton, Whiston, Southport, Warrington, Arrowe Park, North Wales (Wrexham Maelor, Ysbyty Gwynedd, Glan Clwyd), Isle of Man Nobles."
 },
 {
  "id": "gbr-lab-manchester",
  "name": "Transplantation Laboratory, Manchester Royal Infirmary",
  "short": "Manchester",
  "iso3": "GBR",
  "city": "Manchester",
  "region": "",
  "lat": 53.4622,
  "lon": -2.2261,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHS trust. Director Prof Kay Poulton, UKAS 7878 and EFI number carried over from earlier pass, not re-verified. Stoke is a Birmingham NHSBT hospital with Manchester as first reserve, not a Manchester hospital: the atlas has this wrong. EFI 03-GB-009.991. UKAS 7878. Platforms: One Lambda LABType SSO, Luminex, NGS.",
  "note": "Serves: Manchester Royal Infirmary, Wythenshawe, Royal Manchester Children's, North Manchester General, Trafford, Withington, Salford Royal, Stockport Stepping Hill, Tameside, Oldham, Macclesfield, Preston, Blackpool, Blackburn, Burnley, Bolton, Lancaster, Wigan."
 },
 {
  "id": "gbr-lab-leeds",
  "name": "Transplant Immunology Laboratory, St James's University Hospital",
  "short": "Leeds",
  "iso3": "GBR",
  "city": "Leeds",
  "region": "",
  "lat": 53.8067,
  "lon": -1.5195,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHS trust.",
  "note": "Serves: St James's, Leeds General Infirmary, Bradford, Castle Hill, Hull Royal, Dewsbury, Grimsby, Halifax, Harrogate, Huddersfield, Airedale, York, Scarborough, Friarage Northallerton."
 },
 {
  "id": "gbr-lab-bristol-southmead",
  "name": "H&I Laboratory, Southmead Hospital, North Bristol NHS Trust",
  "short": "Bristol (Southmead)",
  "iso3": "GBR",
  "city": "Bristol",
  "region": "",
  "lat": 51.494,
  "lon": -2.59,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHS trust. Distinct from NHSBT Filton, which is a separate legal entity and a separate UKAS location. Gloucestershire Royal is NOT in the Southmead catchment; the atlas lists it wrongly.",
  "note": "Serves: Southmead, Bristol Royal Infirmary, Bristol Royal Hospital for Children, Frenchay, Royal United Bath, North Devon, Weston General, Yeovil, Musgrove Park Taunton."
 },
 {
  "id": "gbr-lab-plymouth",
  "name": "H&I Laboratory, Derriford Hospital",
  "short": "Plymouth",
  "iso3": "GBR",
  "city": "Plymouth",
  "region": "",
  "lat": 50.416,
  "lon": -4.114,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHS trust. Poole, Royal Bournemouth and Dorset County are NOT Plymouth hospitals in INF1466; the atlas lists them wrongly.",
  "note": "Serves: Derriford, Royal Devon and Exeter, Torbay, Royal Cornwall, and as first reserve for North Devon, Taunton and Yeovil."
 },
 {
  "id": "gbr-lab-wtail",
  "name": "Welsh Transplantation and Immunogenetics Laboratory, Welsh Blood Service",
  "short": "WTAIL",
  "iso3": "GBR",
  "city": "Pontyclun",
  "region": "",
  "lat": 51.523,
  "lon": -3.39,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by Welsh Blood Service. INF1466 name is 'Cardiff (WTAIL)'. Hosted by Velindre University NHS Trust, which also hosts UK NEQAS for H&I. UKAS 9326 not re-verified this run. UKAS 9326.",
  "note": "Serves: University Hospital of Wales, Llandough, Morriston, Singleton, Royal Gwent, Royal Glamorgan, Prince Charles, Nevill Hall, Bronglais, Glangwili, Withybush, Prince Philip, Neath Port Talbot, Princess of Wales."
 },
 {
  "id": "gbr-lab-edinburgh",
  "name": "SNBTS Histocompatibility and Immunogenetics, Royal Infirmary of Edinburgh",
  "short": "Edinburgh",
  "iso3": "GBR",
  "city": "Edinburgh",
  "region": "",
  "lat": 55.9218,
  "lon": -3.1382,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by SNBTS. Shares a one-in-four on-call consultant/principal clinical scientist rota with Gartnavel. Covers the east and north of Scotland.",
  "note": "Serves: Royal Infirmary of Edinburgh, Western General, Royal Hospital for Sick Children Edinburgh, Aberdeen Royal Infirmary, Ninewells Dundee, Raigmore Inverness, Victoria Kirkcaldy, St John's Livingston, Borders General, Perth Royal Infirmary."
 },
 {
  "id": "gbr-lab-glasgow-gartnavel",
  "name": "West of Scotland Histocompatibility and Immunogenetics Laboratory, Gartnavel General Hospital",
  "short": "Glasgow (Gartnavel)",
  "iso3": "GBR",
  "city": "Glasgow",
  "region": "",
  "lat": 55.862,
  "lon": -4.339,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by NHS trust. OPERATING, and operated by NHS GREATER GLASGOW AND CLYDE, not SNBTS. Level 1 Laboratory Medicine Building, 21 Shelley Road, G12 0ZD. Molecular, serological and cellular testing for solid organ (kidney and heart), HPC, disease association and pharmacogenetics. Mon-Fri 08:00-16:30 plus 24h transplant on-call. It is also the first reserve lab for the whole of Northern Ireland.",
  "note": "Serves: Queen Elizabeth University Hospital, Royal Hospital for Children Glasgow, Golden Jubilee National Hospital, Glasgow Royal Infirmary, Monklands, Ayr, Dumfries and Galloway, Hairmyres, Belford Fort William, Inverclyde, Western Isles, Crosshouse, Forth Valley Royal, Royal Alexandra Paisley, Wishaw General."
 },
 {
  "id": "gbr-lab-belfast",
  "name": "Northern Ireland Regional H&I Laboratory, Belfast City Hospital",
  "short": "Belfast",
  "iso3": "GBR",
  "city": "Belfast",
  "region": "",
  "lat": 54.5822,
  "lon": -5.9412,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "tier": 2,
  "labNote": "Operated by other. Located in the NI Blood Transfusion building on the Belfast City Hospital site. Reserve labs are Glasgow then Edinburgh. UKAS 9811 not re-verified this run. EU IVDR applies under the Windsor Framework; UKCA is not valid. UKAS 9811.",
  "note": "Serves: Belfast City, Royal Victoria, Mater Infirmorum, Royal Belfast Hospital for Sick Children, Ulster, Antrim, Causeway, South West Acute, Altnagelvin, Craigavon."
 }
] as unknown as Site[];

export const UK_STATS = {
 "transplantUnits": 31,
 "laboratories": 22,
 "nhsbtLabs": 6,
 "volumeRows": 51
};

/* Answers to the questions raised directly, from the verification pass. */
export const UK_NOTES = {
 "q1_hi_lab_count": "CONFIRMED. 22 H&I laboratories in the UK, of which 6 are NHSBT. INF1466/3.1 names 19 'current lab' entities for deceased-donor typing; 'Guy's / Tooting NHSBT' is two physical labs, giving 20 deceased-donor typing labs. Add NHSBT Colindale (registry/cord blood/HLA-selected platelets) and NHSBT Filton (national platelet and granulocyte immunology plus H&I molecular diagnostics), neither of which carries a deceased-donor catchment, and the total is 22. UKAS 9239 Issue 012 (14 Jul 2025) names exactly 6 NHSBT sites under one accreditation: Colindale (code C, Dr Colin Brown), Tooting (T, Dr Deborah Sage), Birmingham (B, Mr Luke Foster), Bristol/Filton (BR, Dr Anthony Poles), Barnsley Blood Centre (BA, Mr Tim Key), Newcastle (N, Dr Arash Akbarzad-Yousefi). Sheffield does not appear: the relocation to Barnsley is complete.",
 "q2_cardiff_liver": "CORRECTED. Cardiff does NOT run a liver transplant programme. The ODT unit list names Cardiff University Hospital of Wales under kidney and pancreas ONLY; it is absent from the liver unit list. Activity Report 2024/25 Table 8.1 lists seven adult liver centres (Birmingham, Cambridge, Edinburgh, King's College, Leeds, Newcastle, Royal Free) and Cardiff is not among them. Cardiff did 7 SPK in 2024/25 (Table 6.8) and 127 adult kidney transplants (Table 5.8). Cardiff's liver involvement is retrieval only. The atlas's hedge was right; delete the doubt and state it as fact.",
 "q3_glasgow_hi_lab": "RESOLVED, AND THE ATLAS HAS THE OPERATOR WRONG. The West of Scotland H&I Laboratory at Gartnavel General Hospital (Level 1, Laboratory Medicine Building, 21 Shelley Road, Glasgow G12 0ZD) IS still operating. The apparent contradiction is an operator error, not a closure: Gartnavel is run by NHS GREATER GLASGOW AND CLYDE, not by SNBTS. The NHS NSS/SNBTS page describes only Edinburgh because Edinburgh is the only H&I lab SNBTS operates. The two labs share a one-in-four on-call consultant/principal clinical scientist rota. Scotland therefore has two H&I labs under two different employers. No phone call needed.",
 "q4_genuine_units": "All seven checked are genuine transplant units, every one of them appearing in Activity Report 2024/25 centre tables with 2024/25 volumes: Coventry 68 adult kidney (formally in partnership with Oxford as a transplant network since 1 June 2016), Portsmouth 93, Nottingham 59 adult plus 10 paediatric, Sheffield 71, St George's 151, Plymouth 52, Bristol Southmead 112 adult plus 14 paediatric. None is a mere referring hospital.",
 "q5_units_with_no_own_lab": "CONFIRMED for all six named, per INF1466/3.1: Royal Papworth -> Cambridge; Nottingham -> Barnsley NHSBT; Queen Elizabeth Hospital Birmingham -> Birmingham NHSBT; Freeman Newcastle -> Newcastle NHSBT; Harefield -> WLRTC (Hammersmith); Wythenshawe -> Manchester. ADD to that list: Sheffield -> Barnsley NHSBT; Coventry -> Birmingham NHSBT; St George's -> Guy's/Tooting NHSBT (Tooting is co-located on the St George's site but is an NHSBT lab, not a St George's one); Portsmouth -> Tooting NHSBT; King's College -> Guy's/Tooting NHSBT; Glasgow QEUH and Golden Jubilee -> Gartnavel; Birmingham Children's -> Birmingham NHSBT; Great Ormond Street -> Royal Free (Anthony Nolan); Evelina -> Guy's/Tooting NHSBT.",
 "q6_volumes": "Populated below from Activity Report 2024/25 (year ending 31 March 2025), the most recent full year. Kidney by centre from Tables 5.8 (adult) and 5.11 (paediatric); liver from Table 8.1; cardiothoracic from Table 7.10; pancreas and islet from Table 6.8. UK totals 2024/25: 3057 adult kidney only (964 living), 115 paediatric kidney only, 874 liver, 322 adult cardiothoracic, 113 SPK."
};
